import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store, Action } from '@ngrx/store';
import { map, tap, take, switchMap } from 'rxjs/operators';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { StoreAction } from '../../models/rootState.model';
import { User, UserEntities } from 'src/app/models/Users';
import { UserHelper } from '../../helpers/user.helpers';

import { selectAuthUserData } from '../selectors/authentication.selectors';
import { selectContextState } from '../selectors/context.selectors';
import { Entity } from './../../../models/entities.model';
import { CONTEXT_ACTION_TYPES, Action_Context_Init_Success, Action_Context_Resset } from './../actions/context.actions';
import * as fromAuth from '../actions/authentication.actions';
import { DirectLinkService } from '../../services/direct-link.service';
import { UtilService } from '../../services/util.service';

@Injectable()
export class ContextEffects {

  constructor(
    private actions$: Actions,
    private router: Router,
    private store: Store<any>
  ) { }

  @Effect({ dispatch: false })
  contextInit$ = this.actions$.pipe(
    ofType(CONTEXT_ACTION_TYPES.CONTEXT_INIT),
    switchMap((action: StoreAction<User>) => this.store.select(selectContextState).pipe(
      take(1),
      map(context => {

        if (context.loaded) { return; }
        if (!action.payload) {
          return this.store.dispatch(new Action_Context_Init_Success(null));
        }
        const userID = action.payload.id;
        const lastContext = localStorage.getItem('context_' + userID);

        let entity = UserHelper.getEntityById(action.payload.id, action.payload.permissions);

        // verify if user has only 2 entites and access the target entity, not the user
        const entities: Entity[] = [];
        Object.keys(action.payload.permissions).forEach(key => {
          if (action.payload.permissions[key]) {
            action.payload.permissions[key].forEach(e => entities.push(e));
          }
        });

        if (lastContext) {
          const _e = UserHelper.getEntityById(parseInt(lastContext), action.payload.permissions);
          if (_e) { entity = _e; }
        }
        else if (entities.length == 2) {
          const sel = entities.find(e => e.source_name !== 'users');
          if (sel) {
            entity = UserHelper.getEntityById(sel.id, action.payload.permissions);
          }
        }

        this.store.dispatch(new Action_Context_Init_Success(entity));
      })
    ))
  );

  @Effect({ dispatch: false })
  contextChanged$ = this.actions$.pipe(
    ofType(CONTEXT_ACTION_TYPES.USER_CHANGED_CONTEXT),
    tap((action: StoreAction<Entity>) => {

      // save last context
      this.store.select(selectAuthUserData).pipe(take(1))
        .subscribe(user => {
          localStorage.setItem('context_' + user.id, action.payload.id.toString());
        });

      // timeout to prevent errors
      setTimeout(() => {

        const redirectOnContextChange = localStorage.getItem('redirectOnContextChange');
        if (redirectOnContextChange){
          localStorage.removeItem('redirectOnContextChange');
          const path = JSON.parse(redirectOnContextChange);
          this.router.navigate(path);
        } else {
          this.router.navigate(['home']);
        }

      }, 200);
    })
  );



  @Effect()
  signout$: Observable<Action> = this.actions$.pipe(
    ofType(fromAuth.AUTH_ACTION_TYPES.SIGNOUT_SUCCESS),
    map(() => new Action_Context_Resset())
  );


  getEntityFromId(contextID: number, permissions: UserEntities): Entity[] {
    let found;
    Object.keys(permissions).forEach(key => {
      const o = permissions[key];
      o.forEach(entity => {
        if (entity.id == contextID) {
          found = entity;
        }
      });
    });
    return found;
  }

}
